import { useState, useCallback } from 'react';
import type { SortField, SortDir } from './assetSortUtils';

export type DialogViewMode = 'list' | 'grid';

export interface AssetPanelPrefs {
  sortField: SortField;
  sortDir: SortDir;
  groupByType: boolean;
  dialogViewMode: DialogViewMode;
}

const STORAGE_KEY = 'spine:assetPanelPrefs';

function loadPrefs(): AssetPanelPrefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return { ...defaultPrefs(), ...JSON.parse(raw) };
  } catch { /* ignore */ }
  return defaultPrefs();
}

function defaultPrefs(): AssetPanelPrefs {
  return { sortField: 'name', sortDir: 'asc', groupByType: false, dialogViewMode: 'list' };
}

function savePrefs(prefs: AssetPanelPrefs) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs)); } catch { /* ignore */ }
}

export function useAssetPanelPrefs() {
  const [prefs, setPrefs] = useState<AssetPanelPrefs>(loadPrefs);

  const update = useCallback((patch: Partial<AssetPanelPrefs>) => {
    setPrefs((prev) => {
      const next = { ...prev, ...patch };
      savePrefs(next);
      return next;
    });
  }, []);

  return { prefs, update };
}
